<template>
	<div class="section">
		<h1>我们的服务</h1>
		<p>提供各种资源导航，帮助你快速找到需要的信息。</p>
	</div>
</template>

<script setup>
</script>

<style scoped>
.section {
	text-align: center;
	font-size: 2em;
	padding: 20px;
}
</style>